import { render, staticRenderFns } from "./PointNewIndex.vue?vue&type=template&id=72cdae6b&scoped=true&"
import script from "./PointNewIndex.vue?vue&type=script&lang=js&"
export * from "./PointNewIndex.vue?vue&type=script&lang=js&"
import style0 from "./PointNewIndex.vue?vue&type=style&index=0&id=72cdae6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cdae6b",
  null
  
)

export default component.exports